import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import * as catalogActions from "../../actions/catalogs";
import * as reportsActions from "../../actions/reports";
import IAction from "../../../types/IAction";
import ReferenceReport from "../../components/referenceReport";

interface Props {
  getClubs: () => void;
  clubs: object[];
  getSantanderReference: (
    clubId: string,
    formaDePago: string,
    fechaInicio: string,
    fechaFin: string,
    page: string,
    size: string
  ) => IAction;
  reportReference: any;
  getSantanderReferenceCsv: (body: object) => IAction;
}

interface State {}

class SantanderReference extends React.Component<Props, State> {
  state = {};

  componentDidMount() {
    this.props.getClubs();
  }

  componentWillUnmount() {}

  render() {
    return (
      <main>
        <Helmet title="Santander Reference" />
        <Layout>
          <ReferenceReport
            clubs={this.props.clubs}
            getSantanderReference={this.props.getSantanderReference}
            reportReference={this.props.reportReference}
            getSantanderReferenceCsv={this.props.getSantanderReferenceCsv}
          />
        </Layout>
      </main>
    );
  }
}

const mapStateToProps = ({ catalogs, reports }) => {
  return {
    clubs: catalogs.clubs,
    reportReference: reports.reportReference
  };
};

const mapDispatchToProps = dispatch => ({
  getClubs: () => {
    dispatch(catalogActions.getClubs());
  },
  getSantanderReference: (
    clubId: string,
    formaDePago: string,
    fechaInicio: string,
    fechaFin: string,
    page: string,
    size: string
  ) => {
    dispatch(
      reportsActions.getSantanderReference(
        clubId,
        formaDePago,
        fechaInicio,
        fechaFin,
        page,
        size
      )
    );
  },
  getSantanderReferenceCsv: (body: object) => {
    dispatch(reportsActions.getSantanderReferenceCsv(body));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SantanderReference);
